// duplicated add to cart button on mobile, which will essentially just trigger the desktop version.

(function () {
    const addToCartMobile = document.querySelector('#mobileCartBtn');
    const addToCartDesktop = document.querySelector('.product-form__submit');

    if (addToCartMobile && addToCartDesktop) {
        addToCartMobile.addEventListener('click', e => {
            addToCartDesktop.click();
        })
    }

})(); 